<template>
  <div class="template">
    <div class="englobe-params">
      <div class="back">
        <GoBackButton path="'/organes'">
          Liste des commissions et autres organes
        </GoBackButton>
        <GoBackButton :path="`/organes/${route.params._id}/missions`">
          Commission
        </GoBackButton>
        <i class="fa-solid fa-chevron-left"></i>Mission
      </div>
    </div>

    <LoaderFullPage v-if="store.loading" />
    <template v-else>
      <div class="commission-zoom">
        <InstituOrganeZoomHeader :organe="store.groupZoom" />

        <RouterRadioButtons :options="routerOptions" />

        <RouterView />
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import GoBackButton from "@follaw-fr/components/general/atoms/GoBackButton.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import RouterRadioButtons from "@follaw-fr/components/reusable/molecules/RouterRadioButtons.vue";
import InstituOrganeZoomHeader from "@follaw-fr/components/institu-groups/atoms/InstituOrganeZoomHeader.vue";
import { useInstituGroupsStore } from "@follaw-fr/stores/institutional-groups";

const store = useInstituGroupsStore();
const route = useRoute();

const routerOptions = computed(() => [
  {
    label: "Composition",
    value: "composition",
  },
  {
    label: "Dernières activités",
    value: "activites",
  },
  {
    label: "Publications",
    value: "publications",
  },
  {
    label: "Agenda",
    value: "agenda",
  },
]);

if (route.params.missionId !== store.groupZoom?._id) {
  store.fetchOneGroup(route.params.missionId);
}
</script>

<style scoped lang="scss">
.commission-zoom {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.back {
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    color: var(--clr-link-default);
    &:hover {
      color: var(--clr-link-hover);
    }
  }
}
</style>
